module.exports = __webpack_public_path__ + "img/menuicon-109-active.7fc36e3f.png";